'use client'
import React, { useState } from 'react'
import CommonNav from '../../commonNav'
import Card from '../../card'
import { Col, Row } from '../../row'
import NoData from '../../noData'
import NoOdds from '../../../../assets/images/error-images/odds.svg'
import Button from '@/shared/components/button'
import usePolling from '@/shared/hooks/usePolling'
import { useLazyQuery } from '@apollo/client'
import { GET_MATCH_ODDS } from '@/graphql/match/match.query'
import { DownArrow, UpArrow } from '@/shared/Icons'

export default function Odds({ data, matchId }: any) {
  const [oddData, setOddData] = useState(data)

  const [activeTab, setActiveTab] = useState<any>({ navItem: 'Inning 1', value: 'firstInningData' })
  const [visibleOddsCount, setVisibleOddsCount] = useState<number>(20)

  const [getOddsData] = useLazyQuery(GET_MATCH_ODDS, { fetchPolicy:'network-only',variables: { input: { iMatchId: matchId }},onCompleted: (data) => {
    setOddData(data.getOddsHistoryByMatchId)
  } })

  usePolling(getOddsData, { interval: 10000 })

  const Tabs = oddData?.firstInningData?.length ? [{ navItem: 'Inning 1', value: 'firstInningData' }] : []
  if (oddData?.secondInningData?.length) Tabs.push({ navItem: 'Inning 2', value: 'secondInningData' })
  if (oddData?.thirdInningData?.length) Tabs.push({ navItem: 'Inning 3', value: 'thirdInningData' })
  if (oddData?.forthInningData?.length) Tabs.push({ navItem: 'Inning 4', value: 'forthInningData' })

  const handleLoadMore = () => {
    setVisibleOddsCount((prevCount) => prevCount + 20)
  }

  return (
    <section className='mb-6'>
      {oddData?.firstInningData?.length ? (
        <>
          <CommonNav
            items={Tabs}
            variant='pills'
            asButton
            className='my-4 !font-bold'
            tabClassName='!text-base !rounded-lg !font-bold h-9'
            onTabChange={setActiveTab}
            isActive={(item) => item?.value === activeTab.value}
          />
          <Row className='gap-x-6 sm:gap-y-4'>
            {oddData[activeTab.value]?.slice(0, visibleOddsCount).map((item: any, index: number) => {
              return (
                <Col key={`${item.sScore}-${item.sOver}-${index}`} xs={12} sm={6}>
                  <Card className='dark:bg-transparent bg-white justify-between rounded-xl items-center' defaultBordered>
                    <div className='h-full p-4 md:px-6 rounded-xl border border-c bg-matchCard'>
                      <p className='text-lg font-bold text-center text-textOffWhite'>{item.sScore}</p>
                      <p className='text-base font-medium text-t-400 text-center'>{item.sOver}</p>
                    </div>
                    <div className='flex flex-col gap-y-2'>
                      <div className='flex items-center justify-end'>
                        <p className='text-xs md:text-base sm:font-medium leading-4 mr-3'>{item?.odds?.favOdds?.title}</p>
                        {item?.odds?.favOdds?.lay && (
                          <div className='flex items-center px-2.5 md:w-16 gap-2 text-xs sm:text-base font-medium py-1.5  text-center rounded-md bg-greenBg mr-2 dark:text-[#E6E6E6] text-[#9EB23E]'>
                            <UpArrow />
                            {item?.odds?.favOdds?.back}
                          </div>
                        )}
                        {item?.odds?.favOdds?.back && (
                          <div className='flex items-center px-2.5 md:w-16 gap-2 text-xs sm:text-base font-medium py-1.5  text-center rounded-md bg-redBg dark:text-[#E6E6E6] text-[#F17083]'>
                            <DownArrow />
                            {item?.odds?.favOdds?.lay}
                          </div>
                        )}
                      </div>
                      <div className='flex items-center justify-end'>
                        <p className='text-xs md:text-base  sm:font-medium leading-4 mr-3'>{item?.sSessionText}</p>
                        {item?.sSessionMax && (
                          <div className='flex items-center gap-2 text-xs sm:text-base font-bold px-2.5 md:w-16 py-1.5  text-center rounded-md bg-greenBg mr-2 dark:text-[#E6E6E6] text-[#9EB23E]'>
                            <UpArrow />
                            {item?.sSessionMin}
                          </div>
                        )}
                        {item?.sSessionMin && (
                          <div className='flex items-center gap-2 text-xs sm:text-base font-bold px-2.5 md:w-16 py-1.5  text-center rounded-md bg-redBg dark:text-[#E6E6E6] text-[#F17083]'>
                            <DownArrow />
                            {item?.sSessionMax}
                          </div>
                        )}
                      </div>
                    </div>
                  </Card>
                </Col>
              )
            })}
          </Row>
          {visibleOddsCount < oddData[activeTab.value]?.length && (
            <div className='text-center my-3'>
            <Button
             className=''
             onClick={handleLoadMore}>
              Load More
            </Button> 
          </div>
          )}
        </>
      ) : (
        <NoData imagePath={NoOdds} />
      )}
    </section>
  )
}
